module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('canvas', {
    ref: "chart"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a0b3cbe2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/InvitationsChart.vue
// module id = 1490
// module chunks = 1